import { EmptyState } from 'components';
import { SimsDaoSim } from 'types/__generated__/SimInventoryApi';
import type {
  CustomCellRendererProps,
  CustomCellRendererReturn,
  SimCellRendererProps,
} from '../SimInventoryTableShared';

interface OrganizationNameProps extends CustomCellRendererProps<SimsDaoSim, SimCellRendererProps> {}

const OrganizationName: React.FC<OrganizationNameProps> = ({ value }): CustomCellRendererReturn =>
  value.organizationName || value.organizationId ? (
    <div>
      {value.organizationName} ({value.organizationId})
    </div>
  ) : (
    <EmptyState />
  );

export default OrganizationName;
